export default {"src":"/_next/static/media/arrow_right.faade943.svg","height":30,"width":30};